<template>
  <div class="chatPopover" v-show="isShow" ref="chatPopover">
    <div class="chatItem" v-for="(value, key) in options" :key="key">
      <div v-if="value == 'setTop'" class="chatItemContent" @click="clickSetTop">
        <img
          class="icon"
          src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/pc/setTopIcon.png"
          alt=""
        />
        <div class="text">置顶</div>
      </div>
      <div v-if="value == 'setUntop'" class="chatItemContent" @click="clickSetUntop">
        <img
          class="icon"
          src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/pc/setUntopIcon.png"
          alt=""
        />
        <div class="text">取消置顶</div>
      </div>
      <div v-if="value == 'edit'" class="chatItemContent" @click="clickEdit">
        <img
          class="icon"
          src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/pc/editIcon.png"
          alt=""
        />
        <div class="text">编辑</div>
      </div>
      <!-- <div v-if="value == 'share'" class="chatItemContent" @click="clickShare">
        <img
          class="icon"
          src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/pc/shareIcon.png"
          alt=""
        />
        <div class="text">分享</div>
      </div> -->
      <div v-if="value == 'report'" class="chatItemContent" @click="clickReport">
        <img
          class="icon"
          src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/pc/reportIcon.png"
          alt=""
        />
        <div class="text">举报</div>
      </div>
      <div v-if="value == 'delete'" class="chatItemContent" @click="clickDelete">
        <img
          class="icon"
          src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/pc/deleteIcon_red.png"
          alt=""
        />
        <div class="text red">删除</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["options", "isShow", "event"],
  methods: {
    // 点击置顶
    clickSetTop: function () {
      this.$emit("clickSetTop");
    },
    // 点击取消置顶
    clickSetUntop: function () {
      this.$emit("clickSetUntop");
    },
    // 点击编辑
    clickEdit: function () {
      this.$emit("clickEdit");
    },
    // 点击分享
    clickShare: function () {
      this.$emit("clickShare");
    },
    // 点击举报
    clickReport: function () {
      this.$emit("clickReport");
    },
    // 点击删除
    clickDelete: function () {
      this.$emit("clickDelete");
    },
  },
  watch: {
    event: function (newVal) {
      if (newVal) {
        // 等待渲染管线 处理完v-show
        this.$nextTick(() => {
          const popoverEl = this.$refs["chatPopover"];
          const popoverRect = this.$refs["chatPopover"].getBoundingClientRect();
          const spacing = 8;
          const viewportWidth = window.innerWidth;
          const viewportHeight = window.innerHeight;
          
          let top = 0;
          let left = 0;
          let placement = "bottom";
          
          // 判断是否存在currentTarget (iOS兼容)
          if (this.event.currentTarget) {
            // 原有逻辑：使用触发元素的位置
            const triggerEl = this.event.currentTarget;
            const triggerRect = triggerEl.getBoundingClientRect();

            // 判断是否可以放在下方
            if (
              triggerRect.bottom + spacing + popoverRect.height <=
              viewportHeight
            ) {
              top = triggerRect.bottom + spacing;
              left = triggerRect.left;
              placement = "bottom";
            }
            // 否则尝试上方
            else if (triggerRect.top - spacing - popoverRect.height >= 0) {
              top = triggerRect.top - spacing - popoverRect.height;
              left = triggerRect.left;
              placement = "top";
            }
            // 再尝试右侧
            else if (
              triggerRect.right + spacing + popoverRect.width <=
              viewportWidth
            ) {
              top = triggerRect.top;
              left = triggerRect.right + spacing;
              placement = "right";
            }
            // 最后尝试左侧
            else if (triggerRect.left - spacing - popoverRect.width >= 0) {
              top = triggerRect.top;
              left = triggerRect.left - spacing - popoverRect.width;
              placement = "left";
            } else {
              // 实在放不下，默认底部强制放置
              top = Math.min(
                triggerRect.bottom + spacing,
                viewportHeight - popoverRect.height
              );
              left = Math.min(
                triggerRect.left,
                viewportWidth - popoverRect.width
              );
              placement = "force-bottom";
            }
          } else {
            // iOS 兼容：使用点击坐标定位
            const clickX = this.event.clientX || 0;
            const clickY = this.event.clientY || 0;
            
            // 默认在点击位置下方打开
            top = clickY + spacing;
            left = clickX - (popoverRect.width / 2); // 水平居中对齐点击位置
            
            // 确保不超出右侧边界
            if (left + popoverRect.width > viewportWidth - spacing) {
              left = viewportWidth - popoverRect.width - spacing;
            }
            
            // 确保不超出左侧边界
            if (left < spacing) {
              left = spacing;
            }
            
            // 如果下方放不下，则尝试放在上方
            if (top + popoverRect.height > viewportHeight - spacing) {
              top = clickY - popoverRect.height - spacing;
              
              // 如果上方也放不下，放在视窗中间
              if (top < spacing) {
                top = Math.max((viewportHeight - popoverRect.height) / 2, spacing);
              }
            }
          }
          
          // 设置样式：fixed 定位
          popoverEl.style.top = `${top}px`;
          popoverEl.style.left = `${left}px`;
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./chatPopover.scss";
</style>
